export const removeTrackerPopup = {
  title: '删除此项目吗？',
  content:
    '确定删除？一旦删除将无法复原<br /><checkbox>我理解删除后将无法复原，我仍要删除。</checkbox>',
  ok: '删除',
  cancel: '取消',
};

export default removeTrackerPopup;
